import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { message } from "antd";
import { getAdminUserInfo } from "Explore/Services/Auth";

export const getUserAboutMe = createAsyncThunk(
  "user/aboutme",
  async (_, { rejectWithValue }) => {
    const func = async () => {
      try {
        const token = localStorage.getItem(
          `${process.env.REACT_APP_PREFIX}_access_token`
        );
        const instance = axios.create({
          baseURL: `${process.env.REACT_APP_API_EXPLORE_BASE_URL}`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        let url = `/user/about_me`;
        const res = await instance.get(url);

        // Fetch admin info to get institution if admin token exists
        const adminToken = localStorage.getItem(
          `${process.env.REACT_APP_PREFIX}_admin_access_token`
        );
        if (adminToken) {
          try {
            const adminInfo = await new Promise((resolve) => {
              getAdminUserInfo((data) => resolve(data));
            });

            if (adminInfo && adminInfo.status === "OK" && adminInfo.data) {
              const adminData = adminInfo.data;
              res.data.admin_institution_id = adminData.institution_id;
              
              const adminInstPerm = adminData.permissions?.find(
                (p) => p.name === "admin_institution"
              );
              if (adminInstPerm) {
                res.data.admin_institution_name = adminInstPerm.scope_name;
              }
              res.data.is_admin = adminData.user_type === "admin";
            }
          } catch (err) {
            console.error("Failed to fetch admin info in getUserAboutMe", err);
          }
        }

        return res;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          return getToken(() => func());
        } else {
          return rejectWithValue(error);
        }
      }
    };

    const res = await func();
    return res.data;
  }
);
export const getToken = (callback) => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_refresh_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_EXPLORE_BASE_URL}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  let url = `/auth/refresh`;
  return instance
    .get(url)
    .then((res) => {
      localStorage.setItem(
        `${process.env.REACT_APP_PREFIX}_access_token`,
        res.data.access_token
      );
      return callback();
    })
    .catch((err) => {
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_access_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_refresh_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_access_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_refresh_token`)
    });

};
